import { configManager } from 'utils/configuration';
import { RaffleConfigs } from '../../../../Raffle.config';

type MainCarouselConfigs = Pick<RaffleConfigs, 'banners'>;

function getConfigs(): MainCarouselConfigs {
  const getConfig = configManager.getInstance().get;

  const { banners } = getConfig('RAFFLE') as RaffleConfigs;

  return {
    banners,
  };
}

export default getConfigs;
